export default __webpack_public_path__ + "static/media/chart_style@2x.5549649f.png";